import { Selectable } from "./selectable";

export interface ScheduleCollection {
    alarmingFrequency: string;
    collectTime: string;
    collectionDays: string;
    customerId: number;
    frequency: string;
    locationCount: number;
    name: string;
    scheduleId: number;
}

export interface ScheduleUpcomingCollectionResponse {
    collectionstart: string;
}

export interface ScheduleCollectionResponse {
    schedules: ScheduleCollection[];
}

export interface ScheduleCollectionRequest {
    scheduleId?: number;

    name: string;
    frequency: number;
    alarmingFrequency: number;
    daysToCollect: Array<number>;
    locations: Array<number>;
    collectionDays?: Array<number>;
    collectTime: string;
}

export const createScheduleCollectionRequest: () => ScheduleCollectionRequest = () => ({
    name: '',
    frequency: 0,
    alarmingFrequency: 0,
    daysToCollect: [],
    locations: [],
    collectionDays: [],
    collectTime: ''
});

export interface ScheduleCollectionDetails {
    alarmingFrequency: string;
    collectTime: string;
    collectionDays: string;
    customerId: number;
    frequency: string;
    locations: Selectable[];
    name: string;
    scheduleId: number;
}
